import * as React from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { IBuilding } from '../../models/dashboard';
import DashboardCell from './DashboardCell';

export interface DashboardRowProps{
    building : IBuilding,
    nRow : number
}

const createSpacing = (nRow: number = 1) => [...Array(nRow)].map( () => <TableCell></TableCell>);

const DashboardRow = (props: DashboardRowProps) => {
    const { building , nRow} = props;
    const [open, setOpen] = React.useState(false);
    const totalTime = Math.round(building.locals.reduce((acc, local) => acc + local.scans.reduce((acc, scan) => acc + scan.time, 0), 0));
    let spacing = (nRow - building.locals.length);
    spacing = spacing < 0 ? 0 : spacing;

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell> {building.floor} </TableCell>
          {building.locals.map((local, i) => <DashboardCell key={i * local.id} local={local} open={open}></DashboardCell> )}
          {createSpacing(spacing)}
          <TableCell>{totalTime} minutes</TableCell>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

export default DashboardRow;